import SignupForm from "./misc/components/SignupForm";
const MerchantSignup = () => {
  return (
    <section className="w-screen h-screen grid place-content-center overflow-hidden">
      <SignupForm />
    </section>
  );
};

export default MerchantSignup;
